import { filter } from "lodash";
import * as Yup from "yup";
import React, { useState, useEffect, useRef } from "react";
import DataTable from "react-data-table-component";
// material
import {
  Box,
  Card,
  Divider,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  InputAdornment,
  Modal,
  Paper,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useFormik, Form, FormikProvider, Formik, useFormikContext } from "formik";
import { Routes } from "src/constant/api_url";
import { getLeaveSettings, updateLeaveSettings } from "src/api/leaveSettings";

import { Stack, Container, TextField, Button, Select, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
// components
import Page from "../components/Page";
import { MemberForm } from "../components/Form/Member";
import { borderRadius } from "@mui/system";

import {
  UpdateSetting,
  getLvbDataApi,
  getSetting,
  getSettingHistory,
  updateInvoiceStart,
  insertLvbDataApi
} from "src/api/updateSetting";
import { notification } from "src/utils/messages";
import { style, updateFrom } from "src/constant/variable";
import moment from "moment";
import { TabContext, TabList } from "@mui/lab";
import Settings from "@mui/icons-material/Settings";
import ReceiptLong from "@mui/icons-material/ReceiptLong";
import UploadIcon from "@mui/icons-material/Upload";
import FormikInput from "src/components/FormikInput ";
import ConfirmationModal from "src/components/ConfirmationModal";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function Setting() {
  const loginUser = JSON.parse(localStorage.getItem("userData"));

  const formikRef = useRef();

  const navigate = useNavigate();
  const [joindate, setjoinDate] = useState(null);
  const [fileimage, setfileimage] = useState();
  const [qrFile, setQrFile] = useState(null);
  const [getdata, setgetdata] = useState({});
  const [historyModal, setHistoryModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [invoiceResetData, setInvoiceResetData] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [tab, setTab] = useState(1);
  const [leaveSettingsData, setLeaveSettingsData] = useState({});
  const [leaveSettingsLabels, setLeaveSettingsLabels] = useState({});
  const [leaveSettingsLoading, setLeaveSettingsLoading] = useState(false);

  const loadLeaveSettings = async () => {
    try {
      const res = await getLeaveSettings();
      if (res?.status === 1) {
        const obj = {};
        const lbl = {};
        (res.output || []).forEach((row) => { obj[row.setting_key] = row.setting_value; lbl[row.setting_key] = row.display_name || row.setting_key; });
        setLeaveSettingsData(obj);
        setLeaveSettingsLabels(lbl);
      }
    } catch (e) {}
  };

  useEffect(() => {
    if (tab === 3) loadLeaveSettings();
  }, [tab]);
  const [isLoading, setIsLoading] = useState(false);
  const [lvbData, setLvbData] = useState({});
  const [lvbDataList, setLvbDataList] = useState([]);
  const [lvbDataModal, setLvbDataModal] = useState(false);
  const [viewLvbDataModal, setViewLvbDataModal] = useState(false);

  const toggleLvbDataModal = () => setLvbDataModal(!lvbDataModal);
  const toggleViewLvbDataModal = () => setViewLvbDataModal(!viewLvbDataModal);

  const toggleHistoryModal = () => setHistoryModal(!historyModal);

  async function fetchchapterlist() {
    try {
      const resp = await getSetting();
      if (resp.status == 1) {
        setgetdata(resp.data);
        setQrFile(`${Routes.API_HOSTNAME}payment-qr-code/${resp.data.payment_qr_code}`);
        const test = new Date(resp.data.lvb_date);
        setjoinDate(test);
      }
    } catch { }
  }

  useEffect(async () => {
    await fetchchapterlist();
  }, []);

  async function fetchSettingHistory() {
    try {
      setIsLoading(true);
      const resp = await getSettingHistory();
      setIsLoading(false);
      if (resp.status == 1) {
        setHistoryData(resp.data);
      }
    } catch { }
  }

  async function getLvbData() {
    try {
      setIsLoading(true);
      const resp = await getLvbDataApi();
      setIsLoading(false);

      if (resp.status == 1) {
        setLvbDataList(resp.data);
      }
    } catch { }
  }

  useEffect(() => {
    if (historyModal) fetchSettingHistory();
  }, [historyModal]);

  useEffect(async () => {
    if (isConfirmed) {
      await updateInvoiceStartHandler(invoiceResetData);
      await fetchchapterlist();
    }
  }, [isConfirmed]);

  const onChangeFunction = (e) => {
    setgetdata({
      ...getdata,
      [e.target.name]: e.target.value
    });
  };

  const lvbDataHandlerFunction = (e) => {
    setLvbData({
      ...lvbData,
      [e.target.name]: e.target.value
    });
  };

  // const handleSubmit = async () => {
  //   const injoindate = joindate;
  //   const dd = injoindate.getDate();
  //   const mm = injoindate.getMonth() + 1;
  //   const yy = injoindate.getFullYear();
  //   const date = dd + "-" + mm + "-" + yy;
  //   const settingData = {
  //     s_id: 1,
  //     joindate: date,
  //     v2v: getdata.v2v,
  //     reference: getdata.reference,
  //     visitor: getdata.visitor,
  //     business: getdata.business,
  //     member: getdata.member,
  //     m_r_fee: getdata.m_r_fee,
  //     n_m_fee: getdata.n_m_fee,
  //     gst: getdata.gst,
  //     b_message: getdata.b_message,
  //     absent_sms_permission: getdata.absent_sms_permission,
  //     enable_advance_search: getdata.enable_advance_search,
  //     blue_tick_point: getdata.blue_tick_point,
  //     green_tick_point: getdata.green_tick_point,
  //     feel_v2v_msg: getdata.feel_v2v_msg,
  //     // my_30_second_msg: getdata.my_30_second_msg
  //     no_of_chapter: getdata.no_of_chapter,
  //     no_of_city: getdata.no_of_city,
  //     no_of_state: getdata.no_of_state,
  //     bank_name: getdata.bank_name,
  //     ifsc_code: getdata.ifsc_code,
  //     account_no: getdata.account_no
  //   };

  //   const jssettingData = JSON.stringify(settingData);
  //   const resp = await UpdateSetting(jssettingData);
  //   let notify = notification({
  //     type: resp.status == 0 ? "error" : "success",
  //     message: resp.message
  //   });
  //   notify();

  //   if (resp.status == 1) {
  //     fetchchapterlist();
  //   }
  // };

  const handleSubmit = async (data) => {
    if (!joindate) return;

    const dd = joindate.getDate();
    const mm = joindate.getMonth() + 1;
    const yy = joindate.getFullYear();
    const date = `${dd}-${mm}-${yy}`;

    const formData = new FormData();

    formData.append("updated_by", loginUser?.u_id);
    formData.append("s_id", 1);

    if (tab == 1) {
      formData.append("tab", 1);
      formData.append("joindate", date);
      // formData.append("v2v", getdata.v2v || 0);
      // formData.append("reference", getdata.reference || 0);
      // formData.append("visitor", getdata.visitor || 0);
      // formData.append("business", getdata.business || 0);
      // formData.append("member", getdata.member || 0);
      formData.append("m_r_fee", getdata.m_r_fee || 0);
      formData.append("n_m_fee", getdata.n_m_fee || 0);
      formData.append("gst", getdata.gst || 0);
      // formData.append("b_message", getdata.b_message || "");
      formData.append("absent_sms_permission", getdata.absent_sms_permission || 0);
      // formData.append("enable_advance_search", getdata.enable_advance_search || 0);
      // formData.append("blue_tick_point", getdata.blue_tick_point || 0);
      // formData.append("green_tick_point", getdata.green_tick_point || 0);
      // formData.append("feel_v2v_msg", getdata.feel_v2v_msg || "");
      // formData.append("no_of_chapter", getdata.no_of_chapter || 0);
      // formData.append("no_of_city", getdata.no_of_city || 0);
      // formData.append("no_of_state", getdata.no_of_state || 0);
      formData.append("bank_name", getdata.bank_name || "");
      formData.append("ifsc_code", getdata.ifsc_code || "");
      formData.append("account_no", getdata.account_no || "");
      formData.append("ac_holder_name", getdata.ac_holder_name || "");
      formData.append("payment_qr_code", fileimage);
    } else if (tab == 2) {
      formData.append("tab", 2);
      formData.append("i_gst_prefix", data.i_gst_prefix);
      formData.append("i_gst_no", data.i_gst_no);
      formData.append("i_gst_sign", data.i_gst_sign);
      formData.append("i_gst_per", data.i_gst_per);
      formData.append("i_gst_b_name", data.i_gst_b_name);
      formData.append("i_gst_ac_no", data.i_gst_ac_no);
      formData.append("i_gst_ifsc_code", data.i_gst_ifsc_code);
      formData.append("i_gst_ac_h_name", data.i_gst_ac_h_name);
      formData.append("i_gst_br_name", data.i_gst_br_name);
      formData.append("i_gst_ac_type", data.i_gst_ac_type);
      formData.append("i_gst_t_c", data.i_gst_t_c);
      formData.append("i_ngst_prefix", data.i_ngst_prefix);
      formData.append("i_ngst_no", data.i_ngst_no);
      formData.append("i_ngst_sign", data.i_ngst_sign);
      formData.append("i_ngst_b_name", data.i_ngst_b_name);
      formData.append("i_ngst_ac_no", data.i_ngst_ac_no);
      formData.append("i_ngst_ifsc_code", data.i_ngst_ifsc_code);
      formData.append("i_ngst_ac_h_name", data.i_ngst_ac_h_name);
      formData.append("i_ngst_br_name", data.i_ngst_br_name);
      formData.append("i_ngst_ac_type", data.i_ngst_ac_type);
      formData.append("i_ngst_t_c", data.i_ngst_t_c);
      formData.append("company_logo", data.company_logo);
      formData.append("company_name", data.company_name);
      formData.append("company_mono", data.company_mono);
      formData.append("company_email", data.company_email);
      formData.append("company_gst_no", data.company_gst_no);
      formData.append("company_pan_no", data.company_pan_no);
      formData.append("company_website", data.company_website);
      formData.append("company_address", data.company_address);
    }

    // ✅ Append fil
    setIsLoading(true);
    const resp = await UpdateSetting(formData);
    setIsLoading(false);

    const notify = notification({
      type: resp.status === 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status === 1) {
      await fetchchapterlist();
    }
  };

  const updateInvoiceStartHandler = async (data) => {
    const resp = await updateInvoiceStart(data);
    const notify = notification({
      type: resp.status === 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    setIsConfirmed(false);
  };

  const handleSubmitLvbData = async () => {
    const finalLvbData = {
      v2v: lvbData?.v2v || 0,
      reference: lvbData?.reference || 0,
      business: lvbData?.business || 0,
      visitor: lvbData?.visitor || 0,
      notes: lvbData?.notes || ""
    };

    const { v2v, reference, business, visitor } = finalLvbData;

    if (
      Number(v2v) <= 0 &&
      Number(reference) <= 0 &&
      Number(business) <= 0 &&
      Number(visitor) <= 0
    ) {
      let notify = notification({
        type: "error",
        message: "Please fill at least one field except notes."
      });
      notify();
      return;
    }

    setIsLoading(true);
    const resp = await insertLvbDataApi(finalLvbData);
    setIsLoading(false);

    const notify = notification({
      type: resp.status === 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp?.status == 1) {
      setLvbData({});
      toggleLvbDataModal();
      fetchchapterlist();
    }
  };

  // Field name mapping
  const settingHistoryFieldName = {
    s_lvb_l_date: "Joining Date",
    absent_sms_permission: "Send SMS to Member",
    v2v: "V2V",
    reference: "Reference",
    business: "Business",
    visitor: "Visitor",
    // member: "Member Strength",
    n_m_fee: "New Member Fees",
    m_r_fee: "Member Renewal Fees",
    gst: "GST",
    // b_message: "Birthday Message",
    // enable_advance_search: "Enable Advance Member Search",
    // green_tick_point: "OBT Complete Point",
    // blue_tick_point: "MGT Complete Point",
    // feel_v2v_msg: "Feel V2V Sheet Message",
    // no_of_chapter: "Number of Chapters",
    // no_of_city: "Number of Cities",
    // no_of_state: "Number of States",
    bank_name: "Bank Name",
    ifsc_code: "IFSC Code",
    account_no: "Account No",
    ac_holder_name: "Account Holder Name",
    payment_qr_code: "QR Code Image",
    i_gst_prefix: "GST Invoice Prefix",
    i_gst_no: "GST Invoice Number",
    i_gst_no_reset: "GST Invoice Number Reset Status",
    i_gst_sign: "GST Signature",
    i_gst_per: "GST Percentage",
    i_gst_b_name: "GST Bank Name",
    i_gst_ac_no: "GST Account Number",
    i_gst_ifsc_code: "GST IFSC Code",
    i_gst_ac_h_name: "GST Account Holder Name",
    i_gst_br_name: "GST Branch Name",
    i_gst_ac_type: "GST Account Type",
    i_gst_t_c: "GST Terms & Conditions",
    i_ngst_prefix: "Non-GST Invoice Prefix",
    i_ngst_no: "Non-GST Invoice Number",
    i_ngst_no_reset: "Non-GST Invoice Number Reset Status",
    i_ngst_sign: "Non-GST Signature",
    i_ngst_b_name: "Non-GST Bank Name",
    i_ngst_ac_no: "Non-GST Account Number",
    i_ngst_ifsc_code: "Non-GST IFSC Code",
    i_ngst_ac_h_name: "Non GST Account Holder Name",
    i_ngst_br_name: "Non GST Branch Name",
    i_ngst_ac_type: "Non GST Account Type",
    i_ngst_t_c: "Non-GST Terms & Conditions",
    company_logo: "Company Logo",
    company_name: "Company Name",
    company_mono: "Company Contact Number",
    company_email: "Company Email",
    company_gst_no: "Company GST Number",
    company_pan_no: "Company PAN Number",
    company_website: "Company Website URL",
    company_address: "Company Address",
    leave_window_months: "Leave window (months)",
    substitute_quota: "Substitute quota per window",
    substitute_window_months: "Substitute window (months)"
  };

  // Value renderer
  const renderValue = (key, value) => {
    if (["absent_sms_permission", "enable_advance_search"].includes(key)) {
      return Number(value) === 1 ? "On" : "Off";
    }
    if (["i_gst_no_reset", "i_ngst_no_reset"].includes(key)) {
      return Number(value) === 1 ? "True" : "False";
    }
    return String(value ?? "-");
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const validationSchema = Yup.object({
    company_name: Yup.string().required("Company Name is required"),
    company_address: Yup.string().required("Company Address is required"),
    company_email: Yup.string()
      .email("Enter valid email address")
      .required("Company email is required")
  });

  const columns = [
    {
      name: "No",
      selector: (row) => row?.l_r_c_id,
      wrap: true,
      sortable: true,
      width: "100px"
    },
    {
      name: "Date",
      wrap: true,
      selector: (row) => row?.date,
      sortable: true
    },
    {
      name: "Created By",
      wrap: true,
      selector: (row) => row?.name,
      sortable: true
    },
    {
      name: "V2V",
      wrap: true,
      selector: (row) => row?.v2v,
      sortable: true
    },
    {
      name: "Reference",
      wrap: true,
      selector: (row) => row?.reference,
      sortable: true
    },
    {
      name: "Business",
      wrap: true,
      selector: (row) => row?.business,
      sortable: true
    },
    {
      name: "Visitor",
      wrap: true,
      selector: (row) => row?.visitor,
      sortable: true
    }
  ];

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.notes != null && data?.notes != "" && (
          <p>
            <b>Notes</b> : {data?.notes}
          </p>
        )}
      </div>
    );
  };

  return (
    <Page title="Setting | Local Vocal Business Group">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Setting
          </Typography>

          <Stack direction="row" spacing={2}>
            {tab === 1 && (
              <>
                <Button
                  onClick={() => {
                    toggleViewLvbDataModal();
                    getLvbData();
                  }}
                  variant="contained"
                >
                  View LVB Data
                </Button>
                <Button onClick={toggleLvbDataModal} variant="contained">
                  Add LVB Data
                </Button>
              </>
            )}
            <Button onClick={toggleHistoryModal} variant="contained">
              Setting History
            </Button>

            {/* <Button onClick={handleSubmit} variant="contained">
              Update
            </Button> */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleSubmit(formikRef?.current?.values);
              }}
              disabled={isLoading}
              startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
            >
              Update
            </Button>
          </Stack>
        </Stack>
        <TabContext value={tab}>
          <Box>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example" centered>
              <Tab icon={<Settings />} iconPosition="start" label="Panel Setting" value={1} />
              <Tab icon={<ReceiptLong />} iconPosition="start" label="Invoice Setting" value={2} />
              <Tab icon={<Settings />} iconPosition="start" label="Leave Setting" value={3} />
            </TabList>
          </Box>
        </TabContext>
        {tab == 1 && (
          <Card style={{ marginBottom: "25px", padding: "25px" }}>
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Stack spacing={0} style={{ marginBottom: "15px" }}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      style={{ marginTop: "15px" }}
                    >
                      <DatePicker
                        type="date"
                        label="Joining Date "
                        value={joindate}
                        disableFuture
                        onChange={(newDate) => setjoinDate(newDate)}
                        renderInput={(params) => <TextField {...params} />}
                        inputFormat="dd/MM/yyyy"
                        defaultValue="0"
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Send SMS to Member</FormLabel>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              name="absent_sms_permission"
                              checked={getdata.absent_sms_permission == 0 ? false : true}
                              onChange={(e) => {
                                let x = 0;
                                if (e.target.checked == true) x = 1;

                                setgetdata({
                                  ...getdata,
                                  [e.target.name]: x
                                });
                              }}
                              value="0"
                            />
                          }
                          label="Send Absent SMS to Member"
                        />
                      </FormGroup>
                    </FormControl>
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="V2V"
                      name="v2v"
                      id="outlined-required"
                      onChange={onChangeFunction}
                      value={getdata.v2v}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Reference"
                      name="reference"
                      onChange={onChangeFunction}
                      value={getdata.reference}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Business"
                      name="business"
                      onChange={onChangeFunction}
                      value={getdata.business}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Visitor"
                      name="visitor"
                      onChange={onChangeFunction}
                      value={getdata.visitor}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Member Strength"
                      name="member"
                      onChange={onChangeFunction}
                      value={getdata.member}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="New Member Fees"
                      name="n_m_fee"
                      InputProps={{
                        startAdornment: <InputAdornment position="start">₹</InputAdornment>
                      }}
                      onChange={onChangeFunction}
                      value={getdata?.n_m_fee}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Member Renewal Fees"
                      name="m_r_fee"
                      InputProps={{
                        startAdornment: <InputAdornment position="start">₹</InputAdornment>
                      }}
                      onChange={onChangeFunction}
                      value={getdata?.m_r_fee}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                {/* <Grid item xs={6}>
                              setgetdata({
                                ...getdata,
                                [e.target.name]: x
                              });
                            }}
                            value="0"
                          />
                        }
                        label="Send Absent SMS to Member"
                      />
                    </FormGroup>
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="V2V"
                    name="v2v"
                    id="outlined-required"
                    // onChange={onChangeFunction}
                    value={getdata.v2v}
                    defaultValue="0"
                    disabled="true"
                  />
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Reference"
                    name="reference"
                    // onChange={onChangeFunction}
                    value={getdata.reference}
                    defaultValue="0"
                    disabled="true"
                  />
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Business"
                    name="business"
                    // onChange={onChangeFunction}
                    value={getdata.business}
                    defaultValue="0"
                    disabled="true"
                  />
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Visitor"
                    name="visitor"
                    // onChange={onChangeFunction}
                    value={getdata.visitor}
                    defaultValue="0"
                    disabled="true"
                  />
                </Stack>
              </Grid>
              {/* <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Member Strength"
                    name="member"
                    onChange={onChangeFunction}
                    value={getdata.member}
                    defaultValue="0"
                  />
                </Stack>
              </Grid> */}
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="New Member Fees"
                      name="n_m_fee"
                      InputProps={{
                        startAdornment: <InputAdornment position="start">₹</InputAdornment>
                      }}
                      onChange={onChangeFunction}
                      value={getdata?.n_m_fee}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Member Renewal Fees"
                      name="m_r_fee"
                      InputProps={{
                        startAdornment: <InputAdornment position="start">₹</InputAdornment>
                      }}
                      onChange={onChangeFunction}
                      value={getdata?.m_r_fee}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>

                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="GST"
                      name="gst"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">%</InputAdornment>
                      }}
                      onChange={onChangeFunction}
                      value={getdata?.gst}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                {/* <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Birthday Message"
                    name="b_message"
                    value={getdata?.b_message}
                    onChange={onChangeFunction}
                    defaultValue=" "
                  />
                </Stack>
              </Grid> */}

                {/* <Grid item xs={6}>
                <Stack>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Enable Advance Member Search</FormLabel>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            name="enable_advance_search"
                            checked={getdata.enable_advance_search == 0 ? false : true}
                            onChange={(e) => {
                              let x = 0;
                              if (e.target.checked == true) x = 1;

                              setgetdata({
                                ...getdata,
                                [e.target.name]: x
                              });
                            }}
                            value="0"
                          />
                        }
                        label="Enable Advance Member Search"
                      />
                    </FormGroup>
                  </FormControl>
                </Stack>
              </Grid> */}

                {/* <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="OBT Complete Point"
                    name="green_tick_point"
                    id="outlined-required"
                    onChange={onChangeFunction}
                    value={getdata.green_tick_point}
                    defaultValue="0"
                  />
                </Stack>
              </Grid> */}
                {/* <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="MGT Complete Point"
                    name="blue_tick_point"
                    id="outlined-required"
                    onChange={onChangeFunction}
                    value={getdata.blue_tick_point}
                    defaultValue="0"
                  />
                </Stack>
              </Grid> */}

                {/* <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="My 30 Second Message"
                    name="my_30_second_msg"
                    value={getdata?.my_30_second_msg}
                    onChange={onChangeFunction}
                    defaultValue=" "
                  />
                </Stack>
              </Grid> */}

                {/* <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Feel V2V Sheet Message"
                    name="feel_v2v_msg"
                    value={getdata?.feel_v2v_msg}
                    onChange={onChangeFunction}
                    defaultValue=" "
                  />
                </Stack>
              </Grid> */}

                {/* <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Number of Chapters"
                    name="no_of_chapter"
                    onChange={onChangeFunction}
                    value={getdata.no_of_chapter}
                    defaultValue="0"
                  />
                </Stack>
              </Grid> */}

                {/* <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Number of Cities"
                    name="no_of_city"
                    onChange={onChangeFunction}
                    value={getdata.no_of_city}
                    defaultValue="0"
                  />
                </Stack>
              </Grid> */}

                {/* <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Number of States"
                    name="no_of_state"
                    onChange={onChangeFunction}
                    value={getdata.no_of_state}
                    defaultValue="0"
                  />
                </Stack>
              </Grid> */}
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Bank Name"
                      name="bank_name"
                      onChange={onChangeFunction}
                      value={getdata.bank_name}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="IFSC Code"
                      name="ifsc_code"
                      onChange={onChangeFunction}
                      value={getdata.ifsc_code}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Account No."
                      name="account_no"
                      onChange={onChangeFunction}
                      value={getdata.account_no}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Account Holder Name"
                      name="ac_holder_name"
                      onChange={onChangeFunction}
                      value={getdata.ac_holder_name}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={2}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    {qrFile != undefined && (
                      <img
                        src={qrFile}
                        alt="img"
                        width="100px"
                        height="80px"
                        style={{ margin: "5px" }}
                      />
                    )}
                  </Stack>
                </Grid>

                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Number of Chapters"
                      name="no_of_chapter"
                      onChange={onChangeFunction}
                      value={getdata.no_of_chapter}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>

                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Number of Cities"
                      name="no_of_city"
                      onChange={onChangeFunction}
                      value={getdata.no_of_city}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>

                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Number of States"
                      name="no_of_state"
                      onChange={onChangeFunction}
                      value={getdata.no_of_state}
                      defaultValue="0"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Bank Name"
                      name="bank_name"
                      onChange={onChangeFunction}
                      value={getdata.bank_name}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="IFSC Code"
                      name="ifsc_code"
                      onChange={onChangeFunction}
                      value={getdata.ifsc_code}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Account No."
                      name="account_no"
                      onChange={onChangeFunction}
                      value={getdata.account_no}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      style={{ marginTop: "0px" }}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="Account Holder Name"
                      name="ac_holder_name"
                      onChange={onChangeFunction}
                      value={getdata.ac_holder_name}
                      defaultValue=" "
                    />
                  </Stack>
                </Grid>
                <Grid item xs={2}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    {qrFile != undefined && (
                      <img
                        src={qrFile}
                        alt="img"
                        width="100px"
                        height="80px"
                        style={{ margin: "5px" }}
                      />
                    )}
                    <Button variant="contained" component="label" sx={{ height: 40 }}>
                      Upload Files
                      <input
                        id="file"
                        name="payment_qr_code"
                        type="file"
                        hidden
                        accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) return;
                          setQrFile(URL.createObjectURL(file));
                          setfileimage(file); // ✅ act
                        }}
                      />
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
          </Card>
        )}
        {tab == 2 && (
          <Card style={{ marginBottom: "25px", padding: "25px" }}>
            <Formik
              innerRef={formikRef}
              initialValues={{
                i_gst_prefix: getdata?.i_gst_prefix,
                i_gst_no: getdata?.i_gst_no,
                i_gst_sign: getdata?.i_gst_sign,
                i_gst_per: getdata?.i_gst_per,
                i_gst_b_name: getdata?.i_gst_b_name,
                i_gst_ac_no: getdata?.i_gst_ac_no,
                i_gst_ifsc_code: getdata?.i_gst_ifsc_code,
                i_gst_ac_h_name: getdata?.i_gst_ac_h_name,
                i_gst_br_name: getdata?.i_gst_br_name,
                i_gst_ac_type: getdata?.i_gst_ac_type,
                i_gst_t_c: getdata?.i_gst_t_c,
                i_ngst_prefix: getdata?.i_ngst_prefix,
                i_ngst_no: getdata?.i_ngst_no,
                i_ngst_sign: getdata?.i_ngst_sign,
                i_ngst_b_name: getdata?.i_ngst_b_name,
                i_ngst_ac_no: getdata?.i_ngst_ac_no,
                i_ngst_ifsc_code: getdata?.i_ngst_ifsc_code,
                i_ngst_ac_h_name: getdata?.i_ngst_ac_h_name,
                i_ngst_br_name: getdata?.i_ngst_br_name,
                i_ngst_ac_type: getdata?.i_ngst_ac_type,
                i_ngst_t_c: getdata?.i_ngst_t_c,
                company_logo: getdata?.company_logo,
                company_name: getdata?.company_name,
                company_mono: getdata?.company_mono,
                company_email: getdata?.company_email,
                company_gst_no: getdata?.company_gst_no,
                company_pan_no: getdata?.company_pan_no,
                company_website: getdata?.company_website,
                company_address: getdata?.company_address
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ setFieldValue, values }) => (
                <>
                  <Form>
                    <Stack>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                          <Stack spacing={2} sx={{ alignItems: "center" }}>
                            <Box
                              sx={{
                                width: 140,
                                height: 150,
                                border: "1px dashed #ccc",
                                borderRadius: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                overflow: "hidden",
                                backgroundColor: "#fafafa",
                                boxShadow: 1,
                                p: 1
                              }}
                            >
                              {values?.company_logo || values?.company_logo_preview ? (
                                <img
                                  src={
                                    values?.company_logo_preview
                                      ? values?.company_logo_preview
                                      : `${Routes.API_HOSTNAME}invoice-setting/${values?.company_logo}`
                                  }
                                  alt="Company Logo"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                  }}
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">
                                  No Logo
                                </Typography>
                              )}
                            </Box>

                            <Button
                              variant="outlined"
                              component="label"
                              startIcon={<UploadIcon />}
                              sx={{
                                textTransform: "none",
                                borderRadius: 1,
                                px: 1
                              }}
                            >
                              Upload Logo
                              <input
                                hidden
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (!file) return;

                                  setFieldValue("company_logo_preview", URL.createObjectURL(file));
                                  setFieldValue("company_logo", file);
                                }}
                              />
                            </Button>
                          </Stack>
                        </Grid>

                        <Grid item xs={12} md={9}>
                          <Grid container spacing={2} sx={{ alignItems: "flex-start" }}>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="company_name" label="Company Name" required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput
                                name="company_mono"
                                label="Company Contact Number"
                                type="tel"
                                numericOnly
                                inputProps={{ maxLength: 10 }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="company_gst_no" label="Company GST Number" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="company_pan_no" label="Company PAN Number" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput
                                name="company_email"
                                label="Company Email"
                                type="email"
                                required
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="company_website" label="Company Website URL" />
                            </Grid>
                            <Grid item xs={12}>
                              <FormikInput
                                name="company_address"
                                label="Company Address"
                                required
                                multiline
                                rows={3}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Divider sx={{ mb: 5, mt: 5 }} />
                      <Grid container spacing={2}>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              mb: 1
                            }}
                          >
                            Invoice (GST)
                          </Typography>
                          <Button
                            variant="contained"
                            onClick={() => {
                              setConfirmationModal(true);
                              setInvoiceResetData({
                                i_gst_no: values?.i_gst_no,
                                i_gst_no_reset: 1
                                // i_ngst_no: values?.i_ngst_no,
                                // i_ngst_no_reset: getdata?.i_ngst_no_reset
                              });
                            }}
                          >
                            Invoice Start Reset
                          </Button>
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <Stack spacing={2} sx={{ alignItems: "center" }}>
                            <Box
                              sx={{
                                width: 140,
                                height: 150,
                                border: "1px dashed #ccc",
                                borderRadius: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                overflow: "hidden",
                                backgroundColor: "#fafafa",
                                boxShadow: 1,
                                p: 1
                              }}
                            >
                              {values?.i_gst_sign || values?.i_gst_sign_preview ? (
                                <img
                                  src={
                                    values?.i_gst_sign_preview
                                      ? values?.i_gst_sign_preview
                                      : `${Routes.API_HOSTNAME}invoice-setting/${values?.i_gst_sign}`
                                  }
                                  alt="Invoice GST Signature"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                  }}
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">
                                  No Logo
                                </Typography>
                              )}
                            </Box>

                            <Button
                              variant="outlined"
                              component="label"
                              startIcon={<UploadIcon />}
                              sx={{
                                textTransform: "none",
                                borderRadius: 1,
                                px: 1
                              }}
                            >
                              Upload
                              <input
                                hidden
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (!file) return;

                                  setFieldValue("i_gst_sign_preview", URL.createObjectURL(file));
                                  setFieldValue("i_gst_sign", file);
                                }}
                              />
                            </Button>
                          </Stack>
                        </Grid>

                        <Grid item xs={12} md={9}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_gst_prefix" label="Invoice Prefix" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_gst_no" label="Invoice Start" numericOnly />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_gst_per" label="GST Percentage" decimalOnly />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_gst_b_name" label="Bank Name" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_gst_ac_no" label="Account No" numericOnly />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_gst_ifsc_code" label="IFSC Code" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_gst_ac_h_name" label="Account Holder Name" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_gst_br_name" label="Branch Name" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_gst_ac_type" label="Account Type" />
                            </Grid>
                            <Grid item xs={12}>
                              <FormikInput
                                name="i_gst_t_c"
                                label="Invoice Terms & Conditions"
                                multiline
                                rows={3}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Divider sx={{ mb: 5, mt: 5 }} />
                      <Grid container spacing={2}>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              mb: 1
                            }}
                          >
                            Invoice(NON GST)
                          </Typography>
                          <Button
                            variant="contained"
                            onClick={() => {
                              setConfirmationModal(true);
                              setInvoiceResetData({
                                // i_gst_no: values?.i_gst_no,
                                // i_gst_no_reset: getdata?.i_gst_no_reset,
                                i_ngst_no: values?.i_ngst_no,
                                i_ngst_no_reset: 1
                              });
                            }}
                          >
                            Invoice Start Reset
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Stack spacing={2} sx={{ alignItems: "center" }}>
                            <Box
                              sx={{
                                width: 140,
                                height: 150,
                                border: "1px dashed #ccc",
                                borderRadius: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                overflow: "hidden",
                                backgroundColor: "#fafafa",
                                boxShadow: 1,
                                p: 1
                              }}
                            >
                              {values?.i_ngst_sign || values?.i_ngst_sign_preview ? (
                                <img
                                  src={
                                    values?.i_ngst_sign_preview
                                      ? values?.i_ngst_sign_preview
                                      : `${Routes.API_HOSTNAME}invoice-setting/${values?.i_ngst_sign}`
                                  }
                                  alt="Invoice Non-Gst Signature"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                  }}
                                />
                              ) : (
                                <Typography variant="body2" color="text.secondary">
                                  No Logo
                                </Typography>
                              )}
                            </Box>

                            <Button
                              variant="outlined"
                              component="label"
                              startIcon={<UploadIcon />}
                              sx={{
                                textTransform: "none",
                                borderRadius: 1,
                                px: 1
                              }}
                            >
                              Upload
                              <input
                                hidden
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (!file) return;

                                  setFieldValue("i_ngst_sign_preview", URL.createObjectURL(file));
                                  setFieldValue("i_ngst_sign", file);
                                }}
                              />
                            </Button>
                          </Stack>
                        </Grid>

                        <Grid item xs={12} md={9}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_ngst_prefix" label="Invoice Prefix" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_ngst_no" label="Invoice Start" numericOnly />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_ngst_b_name" label="Bank Name" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_ngst_ac_no" label="Account No" numericOnly />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_ngst_ifsc_code" label="IFSC Code" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_ngst_ac_h_name" label="Account Holder Name" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_ngst_br_name" label="Branch Name" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormikInput name="i_ngst_ac_type" label="Account Type" />
                            </Grid>
                            <Grid item xs={12}>
                              <FormikInput
                                name="i_ngst_t_c"
                                label="Invoice Terms & Conditions"
                                multiline
                                rows={3}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Stack>
                  </Form>
                </>
              )}
            </Formik>
          </Card>
        )}
      </Container>

      {tab === 3 && (
        <Container>
          <Card style={{ marginBottom: "25px", padding: "25px" }}>
            <Stack spacing={2}>
              <Typography variant="h6">Leave Settings</Typography>
              <Grid container spacing={2}>
                {Object.keys(leaveSettingsData || {}).map((k) => (
                  <Grid item xs={12} sm={6} key={k}>
                    <TextField
                      fullWidth
                      type="number"
                      label={leaveSettingsLabels[k] || k}
                      value={leaveSettingsData[k] || ""}
                      onChange={(e) => setLeaveSettingsData({ ...leaveSettingsData, [k]: e.target.value })}
                    />
                  </Grid>
                ))}
              </Grid>
              <Button
                variant="contained"
                disabled={leaveSettingsLoading}
                onClick={async () => {
                  setLeaveSettingsLoading(true);
                  try {
                    const res = await updateLeaveSettings({ settings: leaveSettingsData });
                    notification({ type: res?.status === 1 ? "success" : "error", message: res?.message || "Saved" })();
                  } catch (e) {}
                  setLeaveSettingsLoading(false);
                }}
              >
                {leaveSettingsLoading ? "Saving..." : "Save"}
              </Button>
            </Stack>
          </Card>
        </Container>
      )}

      <Modal
        open={historyModal}
        onClose={toggleHistoryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ marginBottom: "5px", textAlign: "center" }}
          >
            Setting History
          </Typography>
          <hr />

          {isLoading ? (
            <CustomLoader />
          ) : historyData?.filter((item) => (tab === 2 ? item.update_source == 3 : tab === 3 ? item.update_source == 4 : (item.update_source != 3 && item.update_source != 4)))
              .length > 0 ? (
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: 450,
                overflow: "auto",
                mt: 2,
                backgroundColor: "#f0f2f5"
              }}
            >
              <Table size="small">
                <TableBody>
                  {historyData
                    .filter((item) => (tab === 2 ? item.update_source == 3 : tab === 3 ? item.update_source == 4 : (item.update_source != 3 && item.update_source != 4)))
                    .map((item, index, filteredArray) => {
                    const oldData = JSON.parse(item.old_setting || "{}");
                    const newData = JSON.parse(item.new_setting || "{}");

                    const changedKeys = Object.keys(newData).filter(
                      (key) =>
                        key !== "updated_by" && String(oldData?.[key]) !== String(newData?.[key])
                    );

                    if (!changedKeys.length) return null;

                    return (
                      <TableRow key={index}>
                        <TableCell colSpan={changedKeys.length + 1} sx={{ border: "none" }}>
                          <Paper
                            elevation={0}
                            sx={{
                              mb: 1,
                              mt: 1,
                              borderRadius: 2,
                              borderLeft: "4px solid #1976d2",
                              backgroundColor: "#ffffff",
                              display: "inline-block", // 🔥 important
                              width: "fit-content", // 🔥 important
                              minWidth: "750px",
                              maxWidth: "100%"
                            }}
                          >
                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  width: 150,
                                  minWidth: 150,
                                  maxWidth: 150
                                }}
                              >
                                No
                              </TableCell>
                               <TableCell colSpan={changedKeys.length}>
                                {filteredArray?.length - index}
                              </TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  width: 150,
                                  minWidth: 150,
                                  maxWidth: 150
                                }}
                              >
                                Updated By
                              </TableCell>
                              <TableCell width={"300px"} colSpan={changedKeys.length}>
                                {item.name}
                              </TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  width: 150,
                                  minWidth: 150,
                                  maxWidth: 150
                                }}
                              >
                                Date
                              </TableCell>
                              <TableCell colSpan={changedKeys.length}>
                                {moment(item.updated_at).format("DD-MM-YYYY hh:mm A")}
                              </TableCell>
                            </TableRow>

                            {/* Settings */}
                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  width: 150,
                                  minWidth: 150,
                                  maxWidth: 150
                                }}
                              >
                                Setting
                              </TableCell>
                              {changedKeys.map((key) => (
                                <TableCell key={key} sx={{ minWidth: 160 }}>
                                  {settingHistoryFieldName[key]}
                                </TableCell>
                              ))}
                            </TableRow>

                            {/* Old values */}
                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  width: 150,
                                  minWidth: 150,
                                  maxWidth: 150
                                }}
                              >
                                Old Value
                              </TableCell>
                              {changedKeys.map((key) => (
                                <TableCell
                                  key={key}
                                  sx={{
                                    width: 180,
                                    minWidth: 180,
                                    maxWidth: 180,
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                  }}
                                >
                                  {renderValue(key, oldData?.[key])}
                                </TableCell>
                              ))}
                            </TableRow>

                            {/* New values */}
                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  width: 150,
                                  minWidth: 150,
                                  maxWidth: 150
                                }}
                              >
                                New Value
                              </TableCell>
                              {changedKeys.map((key) => (
                                <TableCell
                                  key={key}
                                  sx={{
                                    width: 180,
                                    minWidth: 180,
                                    maxWidth: 180,
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                  }}
                                >
                                  {renderValue(key, newData?.[key])}
                                </TableCell>
                              ))}
                            </TableRow>

                            <TableRow>
                              <TableCell
                                sx={{
                                  fontWeight: 600,
                                  width: 150,
                                  minWidth: 150,
                                  maxWidth: 150
                                }}
                              >
                                Updated From
                              </TableCell>
                              <TableCell
                                colSpan={changedKeys.length}
                              >{`${updateFrom[item.update_source]}${item.chpt_name !== null ? ` (${item.chpt_name})` : ""}`}</TableCell>
                            </TableRow>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Stack alignItems={"center"}>No History Found</Stack>
          )}

          {/* Footer Buttons */}
          <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ mt: 3 }}>
            <Button variant="outlined" onClick={toggleHistoryModal}>
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          setConfirmationModal={setConfirmationModal}
          setIsConfirmed={setIsConfirmed}
          message={"Are you sure you want to reset invoice no?"}
        />
      )}

      <Modal
        open={lvbDataModal}
        onClose={() => {
          toggleLvbDataModal();
          setLvbData({});
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{ marginBottom: "5px", textAlign: "center" }}
          >
            Add LVB Data
          </Typography>
          <Stack style={{ marginBottom: "15px" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    type="number"
                    label="V2V"
                    name="v2v"
                    onChange={lvbDataHandlerFunction}
                    value={lvbData.v2v}
                    defaultValue="0"
                  />
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    type="number"
                    label="Reference"
                    name="reference"
                    onChange={lvbDataHandlerFunction}
                    value={lvbData.reference}
                    defaultValue="0"
                  />
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    type="number"
                    label="Business"
                    name="business"
                    onChange={lvbDataHandlerFunction}
                    value={lvbData.business}
                    defaultValue="0"
                  />
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    type="number"
                    label="Visitor"
                    name="visitor"
                    onChange={lvbDataHandlerFunction}
                    value={lvbData.visitor}
                    defaultValue="0"
                  />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Note"
                  multiline
                  fullWidth
                  rows={3}
                  value={lvbData?.notes}
                  name="notes"
                  onChange={lvbDataHandlerFunction}
                />
              </Grid>
            </Grid>
          </Stack>
          <Stack spacing={10} style={{ marginBottom: "15px" }}>
            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  toggleLvbDataModal();
                  setLvbData({});
                }}
                style={{ marginRight: "15px" }}
              >
                Close
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitLvbData}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={viewLvbDataModal}
        onClose={toggleViewLvbDataModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography variant="h6" textAlign="center" style={{ marginBottom: "10px" }}>
            LVB Data
          </Typography>
          <Card
            style={{ marginTop: "15px", maxHeight: "400px", overflow: "scroll", width: "100%" }}
          >
            {isLoading ? (
              <CustomLoader />
            ) : (
              <DataTable
                style={{ overflow: "hidden" }}
                filter
                pagination
                highlightOnHover
                columns={columns}
                data={lvbDataList != null ? lvbDataList : []}
                expandableRows
                expandableRowsComponent={ExpandableRow}
                expandableRowDisabled={(row) => !row?.notes}
              />
            )}
          </Card>
          <Stack direction="row" spacing={2} justifyContent="end" mt={2}>
            <Button variant="outlined" onClick={toggleViewLvbDataModal}>
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>
    </Page>
  );
}
